import { boolean, number, object, string } from "yup";

export const updateTemplateSchema = () =>
  object({
    name: string().required("Template Name is required"),
    content: string().required("Content is required"),
    isCommon: boolean(),
    type: number().required("Device type is required"),
    templateCategory: number().required("Device type is required"),
    user: number().required("User is required"),
    pageId: number(),
  });
